import { Paper } from "@material-ui/core";
import React from "react";
import { ImageContainerProps } from "../../../../../../../@types/components/imageConatinerProps.types";
import "./ImageContainer.css";
import { defaultImage } from "../../../../../../../assets";

const ImageContainer = ({ side, backGroundColor, sole_image }: ImageContainerProps) => {
	return (
		<Paper
			elevation={2}
			style={{
				minHeight: "40vh",
				padding: "10px",
				borderRadius: "15px",
				paddingBottom: "3rem",
				backgroundColor: backGroundColor
			}}
		>
			<h2 style={{ color: "#003545" }}>{side} Feet</h2>
			<div className="feetImageContainer">
				<div style={{ width: "100%" }}>
					<h3 style={{ textAlign: "left", marginBottom: "1rem", paddingLeft: "15px" }}>Captured Image</h3>
					<div className="rawImageContainer">
						<div className="image-holder soleImageHolder">
							{sole_image ? <img src={sole_image} alt={`${side} sole`} /> : <img src={defaultImage} />}
							<p>{side} Sole</p>
						</div>
					</div>
				</div>
			</div>
		</Paper>
	);
};

export default ImageContainer;
